import * as React from "react";
const SvgAccessPoint20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 19,
        fill: "black",
        viewBox: "0 0 21 19"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M10.921 2.011a8 8 0 0 0-6.078 13.646L3.43 17.07a10 10 0 1 1 14.142 0l-1.414-1.414a8.002 8.002 0 0 0-2.21-12.877 8 8 0 0 0-3.026-.769Zm4.944 11.66a6.501 6.501 0 0 1-.769.925l-1.414-1.414a4.5 4.5 0 1 0-6.364 0l-1.414 1.414a6.504 6.504 0 0 1-1.765-5.934 6.5 6.5 0 1 1 11.726 5.008ZM9.5 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 0 0-.797 5.893l-.035.052-3 4.5L5.631 19h9.737l-1.036-1.555-3-4.5-.035-.052A3.001 3.001 0 0 0 10.5 7Zm0 8.303L11.632 17H9.369l1.131-1.697Z",
      clipRule: "evenodd"
    })
  );
export default SvgAccessPoint20Px;
